import React, { useState } from "react";
import {
  Box,
  Typography,
  Chip,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const badgeStyle = {
  m: 0.5,
  fontWeight: "bold",
};

const COCmodal = ({ cocDetails = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCOCDetails = cocDetails.filter((item) => {
    const vesselName = item?.contract?.vesselName || "";
    const crewName = item?.contract?.crewName || "";
    return (
      vesselName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      crewName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <Box sx={{ mt: 5, px: 2 }}>
      <Paper
        elevation={3}
        sx={{
          p: 1,
          bgcolor: "#C30B12",
          color: "white",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <TextField
          placeholder="Search by Vessel Name or Crew"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            width: "280px",
          }}
        />

        <Typography
          variant="h6"
          sx={{
            mx: "auto",
            textAlign: "center",
            flex: 1,
            fontWeight: "bold",
            color: "#f5f5f5",
          }}
        >
          COC Details
        </Typography>

        <Box sx={{ width: 300 }} />
      </Paper>

      <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
        {filteredCOCDetails.length > 0 ? (
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contract Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCOCDetails.map((item, index) => {
                const cocDate = item?.date || "N/A";
                return (
                  <TableRow key={item._id || index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{console.log}
                      <Typography fontWeight="bold">
                        Vessel Name: {item?.contract?.vesselName || "N/A"}
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                        <Chip
                          label={`Crew: ${item?.contract?.crewName || "N/A"}`}
                          color="primary"
                          sx={badgeStyle}
                        />
                        <Chip
                          label={`COC Date: ${cocDate}`}
                          sx={{
                            ...badgeStyle,
                            backgroundColor: "#ffe0b2",
                            color: "#e65100",
                          }}
                        />
                        <Chip
                          label={`Indos No.: ${item?.contract?.crewdetails?.indosno || "N/A"}`}
                          color="primary"
                          sx={badgeStyle}
                        />
                      </Box>
                    </TableCell>
                    
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" sx={{ py: 3 }}>
            No matching COC data found.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default COCmodal;
